import { useBreakpoint } from '@context/DeviceBreakpointContext/DeviceBreakpointContext';
import { trackEvent } from '@helpers/analytics';
import { Button, ButtonTheme, Grid, Typography, TypographyType } from '@vivino/js-react-common-ui';
import { BasicVintage, FullVintage } from '@webtypes/goApi';
import React, { useEffect } from 'react';

import { ExternalPromotion } from 'vivino-ui/components/ExternalAd/ExternalAd';

import styles from './contentfulPromoBanner.module.scss';

interface ContentfulPromoBannerProps {
  promotion: ExternalPromotion;
  vintage?: BasicVintage | FullVintage;
}

const ContentfulPromoBanner = ({ promotion, vintage }: ContentfulPromoBannerProps) => {
  if (!promotion || promotion.type !== 'contentful_promo_banner') return null;

  const { button_text, headline, image, link, teaser } = promotion;

  const { isMobile } = useBreakpoint();

  const headlineType = isMobile ? TypographyType.TitleExtraLarge : TypographyType.HeadlineSmall;

  useEffect(() => {
    trackEvent({
      event: 'Campaign - Show',
      props: {
        wineId: vintage?.wine?.id,
        vintageId: vintage?.id,
        campaignName: headline,
        wineryId: vintage?.wine?.winery?.id,
      },
    });
  }, []);

  const onCtaButtonClick = () => {
    trackEvent({
      event: 'Campaign - Click',
      props: {
        wineId: vintage?.wine?.id,
        vintageId: vintage?.id,
        campaignName: headline,
        wineryId: vintage?.wine?.winery?.id,
        cta: button_text,
      },
    });
  };

  return (
    <div className={styles.pdpPromotionBannerWrapper}>
      <a className={styles.pdpPromotionBannerCardLink} href={link} rel="nofollow" target="_blank">
        <div className={styles.pdpPromotionBannerCard}>
          <Grid container spacing={{ xs: 2, sm: 3 }}>
            <Grid xs={12} md={6}>
              <div className={styles.pdpPromotionBannerCardHeader}>
                <picture>
                  <source media="(max-width: 767px)" srcSet={image?.location} />
                  <img className={styles.image} alt={headline || ''} src={image?.location} />
                </picture>
              </div>
            </Grid>

            <Grid xs={12} md={6}>
              <div className={styles.pdpPromotionBannerCardBody}>
                <div>
                  <div className={styles.pdpPromotionBannerCardHeaderHeadline}>
                    <Typography type={headlineType}>{headline}</Typography>
                  </div>
                </div>

                <div className={styles.pdpPromotionBannerCardContent}>
                  <div className={styles.pdpPromotionBannerCardContentText}>
                    <Typography type={TypographyType.BodyMedium}>{teaser}</Typography>
                  </div>

                  <div className={styles.pdpPromotionBannerCardContentButton}>
                    <Button theme={ButtonTheme.Default} onClick={onCtaButtonClick}>
                      {button_text}
                    </Button>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </a>
    </div>
  );
};

export default ContentfulPromoBanner;
